import { createSelector } from '@reduxjs/toolkit';
import { componentsAdapter, pagesAdapter } from './pages.slice';
export const selectPagesStatus = createSelector([
    (state, _) => state.pages.status,
    (_, statusType) => statusType,
], (status, statusType) => {
    if (!statusType) {
        return !!Object.keys(status).find((state) => state === 'pending');
    }
    else {
        return status[statusType] === 'pending';
    }
});
export const selectPagesError = createSelector((state) => state.pages.error, (error) => error);
export const { selectById: selectPageComponentById } = componentsAdapter.getSelectors((state) => state.pages.pageComponents);
export const { selectById: selectPageById } = pagesAdapter.getSelectors((state) => state.pages.pages);
